import React from 'react';

import styled from 'styled-components';

const Outer = styled.div`
  width: 100px;
  display: block;
  height: 15px;
`;
const Inner = styled.div`
  background-color: ${p => p.color || '#fff'};
  border: 2px solid black;
  width: ${p => p.width}%;
  height: 100%;

  transition: width 1000ms cubic-bezier(0.175, 0.885, 0.32, 1.275);
`;

function ProgressBar({ progress, color, className }) {
  return (
    <Outer className={className}>
      <Inner width={progress * 100} color={color} />
    </Outer>
  );
}

export default styled(ProgressBar)``;
